import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
import ConfirmDialog from '../components/common/ConfirmDialog';

const ConfirmContext = createContext(null);

/**
 * Uygulama kökünde monte edilir. Tüm alt bileşenlere promise-tabanlı bir
 * onay fonksiyonu sağlar: `const onay = await confirm({ title, message, ... })`.
 */
export function ConfirmProvider({ children }) {
  const [options, setOptions] = useState(null);
  const resolverRef = useRef(null);

  const confirm = useCallback((opts) => {
    return new Promise((resolve) => {
      resolverRef.current = resolve;
      setOptions(opts || {});
    });
  }, []);

  const close = useCallback((result) => {
    if (resolverRef.current) {
      resolverRef.current(result);
      resolverRef.current = null;
    }
    setOptions(null);
  }, []);

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <ConfirmDialog
        open={options !== null}
        {...(options || {})}
        onConfirm={() => close(true)}
        onCancel={() => close(false)}
      />
    </ConfirmContext.Provider>
  );
}

/**
 * Onay diyaloğunu açan fonksiyonu döndürür. Provider yoksa native
 * window.confirm'e güvenli biçimde geri düşer.
 */
export function useConfirm() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) {
    return (opts) =>
      Promise.resolve(window.confirm((opts && (opts.message || opts.title)) || 'Emin misiniz?'));
  }
  return ctx;
}
